// extracted by mini-css-extract-plugin
export default {"container":"DrawerRadioSelect_container__ZJYb5","labels":"DrawerRadioSelect_labels__Trcn-"};